import { useState } from 'react';
import { IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import Box from '@mui/material/Box';
import { useDelete, useNotify } from 'react-admin';
import { GROUP_AVATARS } from '@/utils/CONST';
import DeleteDialog from '@/components/common/delete-dialog/delete-dialog';

interface Props {
    avatarGroupUriId: string;
}

const DevisActionField = ({ avatarGroupUriId }: Props) => {
    const [deleteOne, { isLoading }] = useDelete();
    const notify = useNotify();
    const [openDeleteModal, setOpenDeleteModal] = useState(false);

    const handleDeleteOne = () => {
        deleteOne(
            GROUP_AVATARS,
            {
                id: avatarGroupUriId,
            },
            {
                onSuccess: () => {
                    notify('ra.notification.deleted', {
                        type: 'success',
                        messageArgs: { smart_count: 1 },
                    });
                    setOpenDeleteModal(false);
                },
                mutationMode: 'optimistic',
            },
        );
    };

    return (
        <Box display={'flex'} justifyContent={'end'} width={'100%'}>
            <IconButton
                disabled={isLoading}
                onClick={() => setOpenDeleteModal(true)}
                color={'primary'}
                sx={{
                    p: 0,
                }}
            >
                <Delete />
            </IconButton>

            {openDeleteModal && (
                <DeleteDialog
                    isLoading={isLoading}
                    onClose={() => setOpenDeleteModal(false)}
                    onClick={handleDeleteOne}
                />
            )}
        </Box>
    );
};

export default DevisActionField;
